// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevMailFormHeaderController {
	/* @ngInject */
	/**
	 */
	constructor() {
		this.data = [];
		this.options = {
			hideFrom: true,
		};
	}
}
